<section
  class="tutorial-page"
  data-testid="case-form-tutorial"
  [attr.lang]="currentLang"
>
  <div class="hero">
    <h1 class="hero-title">{{ "CASE_FORM.TUTORIAL.TITLE" | translate }}</h1>
    <p class="hero-subtitle">{{ "CASE_FORM.TUTORIAL.SUBTITLE" | translate }}</p>
  </div>

  <div
    class="products-carousel"
    aria-roledescription="carousel"
  >
    <button
      type="button"
      class="carousel-nav carousel-nav-prev"
      [attr.aria-label]="prevSlideTitleKey() | translate"
      (click)="prevSlide($event)"
    >
      <span
        class="carousel-nav-label"
        aria-hidden="true"
      >
        {{ prevSlideTitleKey() | translate }}
      </span>
      <svg
        class="carousel-nav-icon"
        width="16"
        height="16"
        viewBox="0 0 20 20"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M12.5 4.5 7 10l5.5 5.5"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <div class="carousel-viewport">
      <div
        class="carousel-track"
        [style.--active-index]="activeSlideIndex()"
      >
        @for (slide of slides; track slide.type; let i = $index) {
          <div
            class="carousel-slide"
            [class.is-active]="activeSlideIndex() === i"
          >
            <div
              class="product-card"
              role="button"
              tabindex="0"
              [ngClass]="slide.cardClass"
              [class.selected]="selectedProduct() === slide.type"
              (click)="changeProduct(slide.type)"
              (keydown.enter)="changeProduct(slide.type)"
              (keydown.space)="changeProduct(slide.type); $event.preventDefault()"
            >
              <div class="card-top">
                <div
                  class="card-badge"
                  [ngClass]="slide.badgeTone"
                >
                  {{ slide.badgeKey | translate }}
                </div>
                @if (selectedProduct() === slide.type) {
                  <div class="selected-pill">
                    {{ "CASE_FORM.TUTORIAL.SELECTED" | translate }}
                  </div>
                }
              </div>
              <div class="card-header">
                <div class="card-icon">
                  <img
                    width="36"
                    height="36"
                    alt=""
                    [src]="slide.cardIcon"
                  />
                </div>
                <h2 class="card-title">{{ slide.titleKey | translate }}</h2>
              </div>
              <p class="card-desc">{{ slide.descKey | translate }}</p>
              <div class="timeline">
                @for (step of slide.steps; track step.titleKey) {
                  <div
                    class="timeline-step"
                    [class.faded]="step.faded"
                  >
                    <div class="step-rail">
                      <div
                        class="step-line step-line-up"
                        [class.dashed]="step.lineUpDashed"
                      ></div>
                      <div
                        class="step-icon-wrapper"
                        [ngClass]="step.tone"
                      >
                        <img
                          width="18"
                          height="18"
                          alt=""
                          [src]="step.icon"
                        />
                      </div>
                      <div
                        class="step-line step-line-down"
                        [class.dashed]="step.lineDownDashed"
                      ></div>
                    </div>
                    <div class="step-content">
                      <div class="step-title">{{ step.titleKey | translate }}</div>
                      <div class="step-desc">{{ step.descKey | translate }}</div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <button
      type="button"
      class="carousel-nav carousel-nav-next"
      [attr.aria-label]="nextSlideTitleKey() | translate"
      (click)="nextSlide($event)"
    >
      <span
        class="carousel-nav-label"
        aria-hidden="true"
      >
        {{ nextSlideTitleKey() | translate }}
      </span>
      <svg
        class="carousel-nav-icon"
        width="16"
        height="16"
        viewBox="0 0 20 20"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M7.5 4.5 13 10l-5.5 5.5"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <div
      class="carousel-dots"
      role="tablist"
      aria-label="Product slides"
    >
      @for (slide of slides; track slide.type; let i = $index) {
        <button
          type="button"
          class="carousel-dot"
          role="tab"
          [class.active]="activeSlideIndex() === i"
          [attr.aria-selected]="activeSlideIndex() === i"
          [attr.aria-label]="slide.titleKey | translate"
          (click)="goToSlide(i, $event)"
        ></button>
      }
    </div>
  </div>

  <div class="cta-section">
    <button
      class="cta-button"
      type="button"
      data-testid="case-form-tutorial-cta"
      [disabled]="loading()"
      (click)="onContinue()"
    >
      <span class="cta-glow"></span>
      <span class="cta-text">{{ "CASE_FORM.TUTORIAL.CTA" | translate }}</span>
    </button>
  </div>
</section>
